module.exports = __webpack_public_path__ + "static/media/menu.a895f716.svg";